import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type TicketDetail } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: TicketDetail.Api.InitRequest
  ): Promise<HttpApiResponse<TicketDetail.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/ticketDetail`, args),

  checkEmail: (apiInfo: ModuleApiInfo, args: TicketDetail.Api.CheckEmailRequest): Promise<HttpApiResponse<boolean>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/ticketDetail/validate`, args),

  getTicketData: (
    apiInfo: ModuleApiInfo,
    args: TicketDetail.Api.GetTicketDataRequest
  ): Promise<HttpApiResponse<TicketDetail.Api.GetTicketDataResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/ticketDetail/data`, args)
};
